module.exports = __webpack_public_path__ + "static/media/pchess.24718ee4.png";